module.exports = __webpack_public_path__ + "static/media/user_manual_help.42b795be.svg";